module.exports = __webpack_public_path__ + "img/23.82eaa489.jpg";